import React from 'react'
import FavoriteItem from './favoriteItem'

const ListFavorite = () => {
  return (
    <div>
      <FavoriteItem/>
      <FavoriteItem/>
      <FavoriteItem/>
    </div>
  )
}

export default ListFavorite